// @flow
import React, { Component }  from "react";
import { Route, Switch } from "react-router-dom";
import GroupsView from "../views/GroupsView";
import ProductsView from "../views/ProductsView";
import ProductView from "../views/ProductView";
import CartView from "../views/CartView";
import CheckoutView from "../views/CheckoutView";
import CheckoutCompleteView from "../views/CheckoutCompleteView";
import OpenpayCheckoutView from "../views/OpenpayCheckoutView";
import OpenpayLandingView from "../views/OpenpayLandingView";
import HomeView from "../views/HomeView";
import LoginView from "../views/LoginView";
import RegisterView from "../views/RegisterView"; 
import AccountView from "../views/AccountView"; 
import ContactRepView from "../views/ContactRepView";
import AboutMeView from "../views/AboutMeView"; 
import PageView from "../views/PageView"; 
import ForgotPasswordView from "../views/ForgotPasswordView";
import OrdersView from "../views/OrdersView";
import CartsView from "../views/CartsView";
import FourOhFourView from "../views/FourOhFourView";
import NearbyConsultants from "../views/NearbyConsultantsView";
import PromotionList from "../components/PromotionList";
import StripeLinkRedirectComponent from "../components/StripeLinkRedirectComponent";
import InvoiceViewer from "../components/InvoiceViewer";



// used to filter initial page load shopname param in index.js
export const RouteNames = ['InvoiceViewer', 'PromotionList', 'stripeLinkPayment', 'login', 'register', 'forgot-password', 'contactrep', 'account', 'about', 'page', 'categories', 'categories', 'cart', 'checkout', 'checkout-complete', 'openpay-checkout', 'openpay', 'products', 'Orders', 'carts', 'search', 'nearby-consultants'];


class AppRoutes extends Component {

    render() {

        return (
            <Switch>
                <Route exact path="/:shopName?/InvoiceViewer/" component={InvoiceViewer} />
                <Route exact path="/:shopName?/stripeLinkPayment/" component={StripeLinkRedirectComponent} />
                <Route exact path="/:shopName?/PromotionList/" component={PromotionList} />
                <Route exact path="/:shopName?/login/" component={LoginView} />
                <Route exact path="/:shopName?/register/:referralCode?" component={RegisterView} />
                <Route exact path="/:shopName?/forgot-password/" component={ForgotPasswordView} />
                <Route exact path="/:shopName?/contactrep/" component={ContactRepView} />
                <Route exact path="/:shopName?/account/:navSection" component={AccountView} />
                <Route exact path="/:shopName?/about/" component={AboutMeView} />
                <Route exact path="/:shopName?/page/:pageId" component={PageView} />
                <Route exact path="/:shopName?/categories/:id/" component={ProductsView} />
                <Route exact path="/:shopName?/categories/" component={GroupsView} />
                <Route exact path="/:shopName?/cart/" component={CartView} />
                <Route exact path="/:shopName?/checkout/" component={CheckoutView} />
                <Route exact path="/:shopName?/checkout-complete/:status?/" component={CheckoutCompleteView} />
                <Route exact path="/:shopName?/openpay-checkout" component={OpenpayCheckoutView} />
                <Route exact path="/:shopName?/openpay" component={OpenpayLandingView} />
                <Route exact path="/:shopName?/products/:id/" component={ProductView} />
                <Route exact path="/:shopName?/Orders/:id?/" component={OrdersView} />
                <Route exact path="/:shopName?/carts/:id?/" component={CartsView} />
                <Route exact path="/:shopName?/nearby-consultants/" component={NearbyConsultants} />
                <Route exact path="/:shopName?/search/:searchTerm/" render={(props) => <ProductsView {...props} showTitle={true} isSearch={true} />} />
                <Route exact path="/:shopName?" render={(props) => <HomeView {...props} settings={this.props.settings} />} />
                <Route component={FourOhFourView} />
            </Switch>
        );
    }
}
export default AppRoutes
